/**
 * LeagueLogo — logos oficiales de las ligas en vez de pelotas genéricas.
 * Imágenes locales en /img/leagues/ (no dependen de CDN externos).
 *
 * Uso:
 *   <LeagueLogo sport="mlb" size={64} />
 */
const LOGOS = {
  football: "/img/leagues/laliga.png",
  soccer: "/img/leagues/laliga.png",
  futbol: "/img/leagues/laliga.png",
  laliga: "/img/leagues/laliga.png",
  ucl: "/img/leagues/ucl.png",
  champions: "/img/leagues/ucl.png",
  premier: "/img/leagues/premier.png",
  basketball: "/img/leagues/nba.png",
  nba: "/img/leagues/nba.png",
  baseball: "/img/leagues/mlb.png",
  mlb: "/img/leagues/mlb.png",
  beisbol: "/img/leagues/mlb.png",
  american_football: "/img/leagues/nfl.png",
  nfl: "/img/leagues/nfl.png",
  americano: "/img/leagues/nfl.png",
  hockey: "/img/leagues/nhl.png",
  nhl: "/img/leagues/nhl.png",
  tennis: "/img/leagues/atp.png",
  tenis: "/img/leagues/atp.png",
  atp: "/img/leagues/atp.png",
};

// El logo de ATP es negro sobre transparente → invertirlo a blanco para fondo oscuro
const INVERT = new Set(["tennis", "tenis", "atp", "ucl", "champions", "premier"]);

export default function LeagueLogo({ sport = "football", size = 48, className = "", style = {} }) {
  const key = String(sport || "football").toLowerCase().replace(/[-\s]/g, "_");
  const src = LOGOS[key] || LOGOS.football;
  const invert = INVERT.has(key);
  return (
    <img
      src={src}
      alt={key}
      width={size}
      height={size}
      className={className}
      style={{
        width: size,
        height: size,
        objectFit: "contain",
        filter: invert ? "brightness(0) invert(1)" : "none",
        ...style,
      }}
      draggable={false}
    />
  );
}
